import * as Sentry from '@sentry/react';

// Initialize Sentry
Sentry.init({
  dsn: 'https://eb93ce19f7f715a16072a4204e6e0398@o4506077112762368.ingest.us.sentry.io/4510041290178560',
  environment: process.env.NODE_ENV || 'development',
  // Performance Monitoring
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const ErrorLog = (errMsg: any) => {
  if (process.env.NODE_ENV === 'development') {
    console.error('error :>', JSON.stringify(errMsg, null, 2));
    console.error(errMsg);
  }
  
  // Always send to Sentry in both dev and production
  Sentry.captureException(errMsg);
};

// Additional Sentry utilities
const logMessage = (message: string, level: 'info' | 'warning' | 'error' = 'info') => {
  Sentry.captureMessage(message, level);
};

const setUserContext = (user: { id?: string; email?: string; username?: string }) => {
  Sentry.setUser(user);
};

const addBreadcrumb = (message: string, category?: string, data?: any) => {
  Sentry.addBreadcrumb({
    message,
    category: category || 'custom',
    data,
    level: 'info',
  });
};

// Test function for development
const testSentry = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Testing Sentry integration...');
    logMessage('Sentry test message', 'info');
    ErrorLog(new Error('Test error for Sentry integration'));
  }
};

export { ErrorLog, logMessage, setUserContext, addBreadcrumb, testSentry };
